export enum LoggerLevelEnum {

  LOG ,
  DEBUG,
  INFO,
  WARN,
  ERROR

}
